/**
 * This is a custom plugin for Video.js file
 * Current functionality of this file is to add
 * video quality button on the video control bar
 *  */

import videojs from 'video.js'

import { VideoPlayerType, VideoQuality } from './VideoPlayer.types'

export interface HomPluginOptions {
  qualityMenu: boolean // show quality menu
  hdicon: boolean // show hd icon
  minhd: number // minimum hd resolution
}

const homvodef = {
  qualityMenu: true,
  hdicon: true,
  minhd: 1080,
}

const vjs_find = (element: Element, i: string): HTMLElement | null => {
  try {
    return element.querySelector(i)
  } catch (err) {
    return null
  }
}

const vjs_El = (elementType: string, className: string | undefined, child: string | undefined): HTMLElement => {
  const Ele = document.createElement(elementType)
  if (void 0 !== className) if ('' !== className) Ele.className = className
  if (void 0 !== child) if ('' !== child) Ele.innerHTML = child
  return Ele
}

function getTech(ele: VideoPlayerType): any {
  return ele.tech(true)
}
function getVhs(ele: VideoPlayerType): any {
  return getTech(ele).vhs
}
function getRepresentations(ele: VideoPlayerType): any {
  return getVhs(ele).representations()
}

const initPlugin = (player: VideoPlayerType, opt: any): void => {
  let options: HomPluginOptions
  try {
    options = videojs.obj.merge(homvodef, opt)
  } catch (er) {
    options = videojs.mergeOptions(homvodef, opt)
  }
  const dom = videojs.dom
  const playerElement = player.el()
  // const videoElement = player.$('.vjs-tech')
  const controlBar = vjs_find(playerElement, '.vjs-control-bar')
  // commented for eslint error
  // let status
  const localizePlayer = (i: string): string => {
    return player.localize(i)
  }

  function addQualityButton(): void {
    const e = vjs_find(playerElement, '.vjs-extend-quality')
    const i = localizePlayer('Auto')
    if (!e) {
      const fullscreenElement = vjs_find(playerElement, '.vjs-fullscreen-control')

      const qualityBtnEle = vjs_El(
        'div',
        'vjs-quality-button vjs-menu-button vjs-control vjs-button vjs-hidden',
        `<div class="vjs-settings-back vjs-control">${i}</div><ul class="vjs-menu-content vjs-quality-menu"></ul>`,
      )
      if (fullscreenElement) {
        controlBar?.insertBefore(qualityBtnEle, fullscreenElement)
      }
    }
  }

  function addQualityIconLabel(e: number): void {
    if (options.hdicon) {
      if (options.qualityMenu) {
        const hdIcon = vjs_find(playerElement, '.vjs-hd')
        if (hdIcon && e > options.minhd - 1) {
          let label = 'HD'
          if (e > 2159) label = '4K'
          hdIcon.innerHTML = label
          dom.removeClass(hdIcon, 'vjs-hidden')
        } else if (hdIcon) {
          dom.addClass(hdIcon, 'vjs-hidden')
        }
      }
    }
  }

  function qualityBind(i: number, t: any): boolean {
    if (player.qualities) {
      const s = getRepresentations(player)
      if ('boolean' === typeof t) {
        player.qualities[i].enabled = t
        s[i].enabled(t)
      }
      return player.qualities[i].enabled
    }
    return !1
  }

  function getPlayerQualityList(element: VideoPlayerType): VideoQuality[] {
    const presentations = getRepresentations(element)
    return presentations.map((t: any, i: number) => {
      const s = `vjs_${i}`
      const n = {
        id: s,
        index: s,
        label: s,
        width: t.width,
        height: t.height,
        bandwidth: t.bandwidth,
        bitrate: t.bandwidth,
        enabled: !1,
      }
      n.enabled = qualityBind.bind(this, i)
      return n
    })
  }
  function hasVideoQualityList(element: VideoPlayerType): boolean {
    return !!getVhs(element)
  }
  function addQualityMenu(): void {
    if (hasVideoQualityList(player)) {
      player.qualities = getPlayerQualityList(player)
      player.setQuality = function (i: number, t: any): void {
        if (player.qualities.length) {
          if ('boolean' === typeof t) {
            player.qualities[i].enabled = t
            getRepresentations(player)[i].enabled(t)
          }
        }
      }

      if (player.qualities.length > 0) {
        addQualityButton()
        // g = e.qualities.length
        setTimeout(() => {
          player.trigger('mediachange')
        }, 500)
        let submenuElement = ''
        player.qualities.forEach((quality: VideoQuality) => {
          let icon = ''
          if (quality.height) {
            const s = parseInt(`${quality.height}`, 10)
            if (options.hdicon && s > options.minhd - 1) {
              let n = 'HD'
              if (s > 1079 && options.minhd < 1080) n = 'FullHD'
              if (s > 2159) n = '4K'
              icon = `<i class="vjs-hd-icon">${n}</i>`
              addQualityIconLabel(s)
            }
          }

          const bitrate = parseInt(`${quality.bitrate}`, 10) || 0
          const height = parseInt(`${quality.height}`, 10) || 0
          let normalizeBitrate = 0
          if (bitrate > 0) normalizeBitrate = Math.round(bitrate / 1e3)
          if (height > 0 || bitrate > 0) {
            const closingTag = `${height}p <i>(${normalizeBitrate} kbps )</i>${icon} </li>`
            const ariaLabel = `${localizePlayer('set quality to ') + height.toString()}p`
            const u = `<li aria-label="${ariaLabel}" data-id="${quality.index}" class="vjs-menu-item item-quality" data-bitrate="${bitrate}" data-height="${height}" tabindex="0" role="menuitemradio" aria-live="off" aria-disabled="false"> ${closingTag}`
            submenuElement += u
          }
        })
        submenuElement += `${
          '<li data-id="auto" class="vjs-menu-item item-quality auto-res vjs-checked" data-height="Autores"' +
          'vjs-menu-item item-quality vjs-checked' +
          ' tabindex="0" aria-label="'
        }${localizePlayer(
          'Set quality automatic',
        )}" role="menuitem" aria-live="off" aria-disabled="false">${localizePlayer('Auto')}<i class="autores"></i></li>`
        const qualityMenuEle = vjs_find(playerElement, '.vjs-quality-menu')
        const qualityButtonEle = vjs_find(playerElement, '.vjs-quality-button')
        if (qualityMenuEle) {
          qualityMenuEle.innerHTML = submenuElement
          if (options.qualityMenu) {
            if (qualityButtonEle) {
              dom.removeClass(qualityButtonEle, 'vjs-hidden')
            }
          }
        }
        const qualityBtn = vjs_find(playerElement, '.vjs-settings-back')
        if (qualityBtn) {
          qualityBtn.onclick = function (e) {
            e.preventDefault()
            e.stopImmediatePropagation()
            if (qualityButtonEle) {
              const qualityMenu = vjs_find(playerElement, '.vjs-quality-menu')
              const isShowing = dom.hasClass(qualityButtonEle, 'vjs-lock-showing')
              if (isShowing) {
                if (qualityMenu) {
                  dom.addClass(qualityMenu, 'vjs-hidden')
                }
                dom.removeClass(qualityButtonEle, 'vjs-lock-showing')
              } else {
                if (qualityMenu) {
                  dom.removeClass(qualityMenu, 'vjs-hidden')
                }
                dom.addClass(qualityButtonEle, 'vjs-lock-showing')
              }
            }
          }
        }

        const qualityMenuItems = playerElement.querySelectorAll('.item-quality')
        qualityMenuItems.forEach((qualityMenuItem: HTMLElement, index: number) => {
          qualityMenuItem.onclick = function (e) {
            e.preventDefault()
            e.stopImmediatePropagation()
            qualityMenuItems.forEach((item: HTMLElement) => {
              dom.removeClass(item, 'vjs-checked')
            })
            player.qualityIndex = index
            // commented for eslint error
            // status = player.qualities[index]
            dom.addClass(qualityMenuItem, 'vjs-checked')
            const { id, height, bitrate } = qualityMenuItem.dataset
            player.trigger('resolutionchange', { id: '', res: height })
            // eslint-disable-next-line fp/no-loops
            for (let c = 0; c < player.qualities.length; c++) {
              if (!player.hlsjs) player.setQuality(c, false)
              if (
                player.qualities[c].height === parseInt(height ?? '', 10) ||
                player.qualities[c].bitrate === parseInt(bitrate ?? '', 10)
              ) {
                if (player.hlsjs) {
                  player.hlsjs.currentLevel = c
                } else {
                  player.setQuality(c, !0)
                }
              }
            }
            if (qualityButtonEle) {
              dom.removeClass(qualityButtonEle, 'vjs-lock-showing')
            }
            if (qualityBtn) {
              qualityBtn.innerHTML = `${id === 'auto' ? 'Auto' : height}p`
            }
          }
        })
      }
    }
  }

  player.one('playing', addQualityMenu)
  player.one('levelsLoaded', addQualityMenu)
  player.on('qualityChange', () => {
    if (player.qualities.length) {
      // commented for eslint error
      // status = player.qualities[player.qualityIndex]
    }
  })
  player.on('mediachange', () => {
    const vhs = getVhs(player)
    if (vhs) {
      const i = vhs
      const t = i.representations()
      const s = i.playlists.media()
      if (s) {
        // eslint-disable-next-line fp/no-loops
        for (let n = s.attributes.BANDWIDTH, a = s.attributes.RESOLUTION.height, o = 0; o < t.length; o++) {
          if (n === t[o].bandwidth) {
            player.qualityIndex = o
            break
          }
          if (a === t[o].height) {
            player.qualityIndex = o
            break
          }
        }
        player.trigger('qualityChange')
      }
    }
  })
}
const HomVjs = function (options: HomPluginOptions): void {
  this.ready(function () {
    initPlugin(this, options)
  })
}
HomVjs.VERSION = '0.0.1'
if ('undefined' !== typeof window) videojs.registerPlugin('HomVjs', HomVjs)
export default HomVjs
